var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0169 13.4805C13.3564 13.4805 13.7044 13.3022 14.0609 12.9457L21.4457 5.63738C21.1288 5.33746 20.5488 5.1875 19.7056 5.1875H6.03956C5.32089 5.1875 4.82292 5.32614 4.54563 5.60342L11.9728 12.9457C12.3237 13.3022 12.6717 13.4805 13.0169 13.4805ZM3.84111 18.4461L9.84228 12.5128L3.82414 6.57957C3.69398 6.8229 3.62891 7.23316 3.62891 7.81036V17.1814C3.62891 17.7812 3.69964 18.2028 3.84111 18.4461ZM6.29421 19.8127H19.9602C20.6676 19.8127 21.1627 19.6769 21.4457 19.4053L15.3257 13.3447L14.7655 13.9134C14.1939 14.4566 13.6111 14.7283 13.0169 14.7283C12.417 14.7283 11.8342 14.4566 11.2683 13.9134L10.6996 13.3447L4.59656 19.3968C4.91912 19.6741 5.485 19.8127 6.29421 19.8127ZM22.1672 18.4376C22.303 18.1886 22.3709 17.7699 22.3709 17.1814V7.81036C22.3709 7.23882 22.3087 6.83704 22.1842 6.60503L16.183 12.5128L22.1672 18.4376Z",
    fill: "#FFC83E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailMiniIcon);
export default __webpack_public_path__ + "static/media/emailMiniIcon.ef9eb8d958f0c91f7e35a45f61fabbeb.svg";
export { ForwardRef as ReactComponent };